export function articleSlug(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "") || "artikull";
}

export function articleIdentifier(article) {
  return String(article?.id || articleSlug(article?.title));
}

export function articleHref(article) {
  return `/artikuj/${encodeURIComponent(articleIdentifier(article))}`;
}

export function findArticle(articles, identifier) {
  const wanted = decodeURIComponent(String(identifier || ""));
  return (articles || []).find((article) => (
    String(article?.id || "") === wanted || articleSlug(article?.title) === wanted
  ));
}
